<!--
 * @Description: 授权码组件
 * @Version: 1.0
 * @Autor: zhangle
 * @Date: 2026-05-26
 * @LastEditors: zhangle
 * @LastEditTime: 2026-05-26
-->
<template>
    <div class="tsa-authorization-code" v-show="show">
        <div class="mask"></div>
        <div class="content">
            <div class="title-top">
                <h4>验证码</h4>
                <img @click="close" src="/static/img/icon/close.png" alt="">
            </div>
            <div class="scroll">
                <div class="form">
                    <div class="item">
                        <div class="value">
                            <input type="text" v-model="code" placeholder="请输入验证码">
                            <button class="code" :disabled="counting" @click="getCode">{{ btnText }}</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="bottom">
                <div class="btn confirm" @click="confirm">
                    <p>确认</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue'
import {  } from '@/api/common';
import { phoneReg } from '@/config/regular';
import { signAuthorizationConfirmApi, signAuthorizationSendCodeApi } from '@/api/common'
import { setBodyOverflow } from '@/js/utils'
import NoTrace from '@/js/noTrace';
export default {
    name: 'TsaAuthorizationCode',
    data () {
        return {
            show: false,
            code: '',
            counting: false,
            countdown: 60,
            timer: null,
            verificationId: '',
            contractId: '',
            signSessionId: '',
            authorizationOssKey: '',
        }
    },
    computed: {
        btnText () {
            return this.counting ? `${this.countdown}s后重发` : '获取验证码'
        }
    },
    watch: {
        show (val) {
            setBodyOverflow(val)
            if (!val) {
                this.clearTimer()
                this.code = ''
                this.verificationId = ''
                this.contractId = ''
                this.signSessionId = ''
                this.authorizationOssKey = ''
            }
        }
    },
    beforeDestroy () {
        this.clearTimer()
    },
    methods: {
        close () {
            this.show = false
        },
        confirm () {
            let code = this.code.trim()
            if (!code) {
                this.$toast('请输入验证码')
                return
            }
            this.$TsaLoading.show()
            signAuthorizationConfirmApi({
                code: this.code,
                verificationId: this.verificationId,
                contractId: this.contractId,
                signSessionId: this.signSessionId,
                authorizationOssKey: this.authorizationOssKey
            }).then((res) => {
                this.$TsaLoading.hide()
                if (res.code == '0') {
                    // 正式核验记录ID（工商验证通过后新建的完整记录）
                    this.show = false
                    let verificationId = res.data.verificationId
                    this.onConfirm && this.onConfirm({
                        verificationId
                    })
                }
            }).catch(() => {
                this.$TsaLoading.hide()
            })
            
        },
        getCode () {
            // 人机校验
            NoTrace.start({
                success: (nvc) => {
                    if (this.counting) return
                    this.counting = true
                    this.countdown = 60
                    this.timer = setInterval(() => {
                        this.countdown--
                        if (this.countdown <= 0) {
                            this.clearTimer()
                            this.counting = false
                        }
                    }, 1000)
                    signAuthorizationSendCodeApi({
                        nvc
                    }).then((res) => {
                        if (res.code == '0') {
                            this.$toast('验证码已发送至账号绑定的手机号中，请查收')
                        } else {
                            this.clearTimer()
                        }
                    }).catch(() => {
                        this.clearTimer()
                    })
                },
                fail: () => {
                    console.log('fail')
                    this.$toast('人机校验失败')
                }
            })
        },
        clearTimer () {
            if (this.timer) {
                clearInterval(this.timer)
                this.timer = null
            }
            this.counting = false
            this.countdown = 60
        }
    }
}
</script>

<style lang="less" scoped>
    .tsa-authorization-code {
        position: fixed;
        z-index: 9;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        * {
            box-sizing: border-box;
        }
        .mask {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, 0.65);
        }
        .content {
            display: flex;
            flex-direction: column;
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            width: 100%;
            max-height: 95%;
            border-radius: 8px;
            background: #FFFFFF;
            border-radius: 16px 16px 0px 0px;
            .title-top {
                flex-shrink: 0;
                width: 100%;
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 16px;
                padding: 16px 20px 0 16px;
                h4 {
                   font-weight: bold;
                    font-size: 20px;
                    color: #000000;
                }
                img {
                    width: 24px;
                    height: 24px;
                }
            }
            .scroll {
                flex: 1;
                overflow-y: auto;
                -webkit-overflow-scrolling: touch;
                padding: 0 16px;
            }
            .form {
                .item {
                    margin-bottom: 24px;
                    .name {
                        font-weight: bold;
                        font-size: 14px;
                        color: #333333;
                        margin-bottom: 8px;
                    }
                    .value {
                        width: 100%;
                        display: flex;
                        align-items: center;
                        background: #F7F9FD;
                        border-radius: 8px;
                        padding: 8px 12px;
                        border: 1px solid #F7F9FD;
                        input {
                            flex: 1;
                            font-size: 14px;
                            color: #333333;
                            border: 0;
                            outline: none;
                            -webkit-appearance: none;
                            appearance: none;
                            background-color: transparent;
                            &::placeholder {
                                font-size: 14px;
                                color: #666666;
                            }
                        }
                        button {
                            font-size: 14px;
                            color: #0047FF;
                            border: 0;
                            outline: none;
                            background: transparent;
                            -webkit-appearance: none;
                            appearance: none;
                            padding: 0;
                            margin: 0;
                            cursor: pointer;
                            white-space: nowrap;
                            flex-shrink: 0;

                            &:disabled {
                                color: #999999;
                                cursor: not-allowed;
                            }
                        }
                    }
                }
            }
            .bottom {
                flex-shrink: 0;
                width: 100%;
                display: flex;
                padding: 16px;
                box-shadow: 0px -4px 20px 0px rgba(0,0,0,0.05);
                .btn {
                    flex: 1;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 162px;
                    height: 44px;
                    border-radius: 8px;
                    border: 1px solid #D9D9D9;
                    p {
                        font-weight: bold;
                        font-size: 14px;
                        color: #000000;
                    }
                }
                .confirm {
                    margin-left: 12px;
                    background: linear-gradient( 90deg, #0047FF 0%, #2377FF 100%);
                    p {
                        color: #FFFFFF;
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/authorizationCode/index.vue